<mat-action-list
  class="font-sans min-h-[calc(100vh_-_80px)] z-[1] m-0 fixed w-[117px] bg-project-800 m-sidebar"
>
  <a
    class="m-nav__item"
    [routerLink]="['/dashboard']"
    routerLinkActive="m-nav__item--active"
  >
    <i class="m-nav__item-icon icon-cms-articles"></i>
    <span class="m-nav__item-label">Content</span>
  </a>
  <a
    class="m-nav__item"
    [routerLink]="['/content-list']"
    routerLinkActive="m-nav__item--active"
  >
    <i class="m-nav__item-icon icon-list"></i>
    <span class="m-nav__item-label">Content Lists</span>
  </a>
  <a
    href="{{ cmsUrl }}/#/images?resetSelectionService=1&searchString="
    class="m-nav__item"
  >
    <i class="m-nav__item-icon icon-cms-library"></i>
    <span class="m-nav__item-label">Media Library</span>
  </a>
  <a
    class="m-nav__item"
    [routerLink]="['/reporting']"
    routerLinkActive="m-nav__item--active"
  >
    <i class="m-nav__item-icon icon-cms-stats"></i>
    <span class="m-nav__item-label">Reporting</span>
  </a>
  <a
    class="hidden m-nav__item"
    href="{{ cmsUrl }}/poll"
    routerLinkActive="m-nav__item"
  >
    <i class="m-nav__item-icon icon-tachometer"></i>
    <span class="m-nav__item-label">Polls</span>
  </a>
  <!-- <a
    class="m-nav__item"
    [routerLink]="['/managers']"
    routerLinkActive="m-nav__item--active"
  >
    <i class="m-nav__item-icon icon-cms-users"></i>
    <span class="m-nav__item-label">Manager Profiles</span>
  </a> -->
  <a href="{{ cmsUrl }}/#/adverts/markup/create" class="m-nav__item">
    <i class="m-nav__item-icon icon-gears"></i>
    <span class="m-nav__item-label">Native Ad Generator</span>
  </a>
  <a href="{{ shakespeareUrl }}" class="m-nav__item">
    <i class="m-nav__item-icon icon-exchange"></i>
    <span class="m-nav__item-label">Old CMS</span>
  </a>
  <a
    *ngIf="canEditTopic"
    class="m-nav__item"
    [routerLink]="['/admin/topics']"
    routerLinkActive="m-nav__item--active"
  >
    <i class="m-nav__item-icon icon-tags"></i>
    <span class="m-nav__item-label">Topics</span>
  </a>
  <a
    class="m-nav__item"
    [routerLink]="['/user-settings']"
    routerLinkActive="m-nav__item--active"
  >
    <i class="m-nav__item-icon icon-cms-users"></i>
    <span class="m-nav__item-label">Settings</span>
  </a>

  <a *ngIf="isAdmin" href="{{ cmsUrl }}/#/admin" class="m-nav__item-last">
    <i class="m-nav__item-icon icon-cms-cog"></i>
    <span class="m-nav__item-label">Admin</span>
  </a>
</mat-action-list>
